import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { cn } from "@/lib/utils";

const TZ = "America/Sao_Paulo";

export function countdownText(b, now) {
  const end = new Date(b.ends_at);
  const ms = end - now;
  if (b.countdown === "24h" && ms > 864e5) {
    const f = (o) => end.toLocaleString("pt-BR", { timeZone: TZ, ...o });
    const [h, m] = f({ hour: "2-digit", minute: "2-digit", hour12: false }).split(":");
    const day = `${f({ weekday: "short" }).replace(".", "")} ${f({ day: "2-digit", month: "2-digit" })}`;
    return { urgent: false, text: `Até ${day}${h === "23" && m === "59" ? "" : `, ${h}h${m === "00" ? "" : m}`}` };
  }
  const min = Math.floor(ms / 6e4);
  const d = Math.floor(min / 1440), h = Math.floor((min % 1440) / 60), mm = min % 60;
  const text = d ? `${d} dia${d > 1 ? "s" : ""} ${h}h` : h ? `${h}h ${mm}min` : mm ? `${mm} min` : "menos de 1 min";
  return { urgent: true, text: `Termina em ${text}` };
}

function Countdown({ b, now }) {
  const cd = countdownText(b, now);
  return (
    <span className={cn("absolute left-3 top-3 flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold text-white shadow-lg backdrop-blur sm:left-4 sm:top-4 sm:text-sm", cd.urgent ? "bg-red-600/90" : "bg-black/60")} data-testid="shop-banner-countdown">
      <Clock className="h-3.5 w-3.5 sm:h-4 sm:w-4" />{cd.text}
    </span>
  );
}

export function ShopBanner({ banners, color }) {
  const [now, setNow] = useState(() => new Date());
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 30000); return () => clearInterval(t); }, []);
  const list = banners.filter((b) => !b.ends_at || new Date(b.ends_at) > now);
  const n = list.length;
  useEffect(() => {
    if (n < 2) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % n), 5000);
    return () => clearInterval(t);
  }, [n, i]);
  const cur = n ? i % n : 0;
  return (
    <div className="relative h-44 overflow-hidden rounded-2xl sm:h-72 lg:h-[420px]" style={{ background: `linear-gradient(135deg, ${color}, ${color}99)` }} data-testid="shop-banner">
      {list.map((b, j) => (
        <img key={b.url} src={imgUrl(b.url)} alt={`Banner ${j + 1}`} className={cn("absolute inset-0 h-full w-full object-cover transition-opacity duration-700", j === cur ? "opacity-100" : "opacity-0")} data-testid={`shop-banner-img-${j}`} />
      ))}
      {list[cur]?.countdown && <Countdown b={list[cur]} now={now} />}
      {n > 1 && (
        <div className="absolute bottom-3 right-4 flex gap-1.5" data-testid="shop-banner-dots">
          {list.map((b, j) => (
            <button key={b.url} onClick={() => setI(j)} aria-label={`Ver banner ${j + 1}`} className={cn("h-2 rounded-full bg-white shadow transition-[width,opacity] duration-300", j === cur ? "w-6 opacity-100" : "w-2 opacity-60")} data-testid={`shop-banner-dot-${j}`} />
          ))}
        </div>
      )}
    </div>
  );
}
